import { useLocation } from 'react-router-dom'

const useHash = () => {
  const { hash } = useLocation()

  if (hash.includes('#')) {
    return hash.slice(1)
  }
  return hash
}

export default useHash
